module.exports = __webpack_public_path__ + "img/NielsKlim_Innhold2.73b4e849.jpg";